import React from 'react';

class MaxWeights extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck
	}

	render() {
		let bridgeWeights = this.truck.calculateBridgeWeights();

		// Get Bridge Length
		let bridgeLength = {
			feet: 0,
			inches: 0,
		};
		for (let i = 0; i < this.truck.axleCount; ++i) {
			bridgeLength.feet = bridgeLength.feet + this.truck.feet[i];
			bridgeLength.inches = bridgeLength.inches + this.truck.inches[i];
		}

		// Carry over inches to feet
		if (bridgeLength.inches > 11) {
			let inches = bridgeLength.inches % 12;
			let extraFeet = Math.floor(bridgeLength.inches / 12);

			bridgeLength.feet += extraFeet;
			bridgeLength.inches = inches; 
		}

		// Get total bridge weight
		let legalWeightIndex = 0;
		for (let i = 0; i < bridgeWeights.startAxle.length; ++i) {
			if (bridgeWeights.startAxle[i] === 0 &&
				bridgeWeights.endAxle[i] === this.truck.axleCount - 1) {
					legalWeightIndex = i;
					break;
				}
		}
		let legalWeight9 = bridgeWeights.weight9Ton[legalWeightIndex];
		let legalWeight10 = bridgeWeights.weight10Ton[legalWeightIndex];

		return (
			<div className="section">
				<span>Maximum Weights Based on Axel Group Spacing</span>
				<table>
					<thead>
						<tr>
							<th>Axles</th>
							<th>Bridge Length</th>
							<th>Legal Weight (10 ton road)</th>
							<th>Legal Weight (9 ton road)</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1 to {this.truck.axleCount}</td>
							<td>{bridgeLength.feet}'{bridgeLength.inches}"</td>
							<td>{legalWeight10}</td>
							<td>{legalWeight9}</td>
						</tr>
					</tbody>
				</table>
			</div>
			
		);
	}	
}

export default MaxWeights;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/MaxWeights.js